import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { PropertyType } from '../../common/helpers/domain/propertyTypes';
import { State } from './type';
import { LandingPageTypes } from '../../common/helpers/domain/landingPages';

const initialState: State = {
  propertyType: undefined,
  pageType: undefined,
};

const hydrate = createAction<{ home: State }>(HYDRATE);

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    updateInitialProps: (
      state,
      action: PayloadAction<{ propertyType: PropertyType }>,
    ) => {
      state.propertyType = action.payload.propertyType;
    },
    updatePageType: (state, action: PayloadAction<LandingPageTypes>) => {
      state.pageType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(hydrate, (state, action) => {
      return { ...state, ...action.payload.home };
    });
  },
});

export const { updateInitialProps, updatePageType } = homeSlice.actions;

export default homeSlice.reducer;
